import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';
import {MenuItemType} from '@models/sidebar/menu-item-type';

@Component({
    selector: 'scitis-status-event-page-clone',
    templateUrl: './status-event-page-clone.component.html',
    styleUrls: ['./status-event-page-clone.component.scss'],
    standalone: false
})
export class StatusEventPageCloneComponent implements OnInit {
  public isLoadingOrganizations: boolean = false;
  public isLoadingMachinesOfOrganization: boolean = false;
  public searchTerm: string = '';

  @Input()
  public pageType: MenuItemType = MenuItemType.NONE;
  @Input()
  public pageName: string = '';
  @Input()
  public machineId: string = '';
  @Input()
  public pageId: string = '';
  @Input()
  public organizationId: string | null = null;
  @Input()
  public machineCategory: string | null = null;

  public selectedMachineIds: number[] = [];
  public modalTitle: string = '';
  public modalCloningProcessNotification: string = '';

  public shouldDisableCopyButton: boolean = false;

  constructor(
      private activeModal: NgbActiveModal,
      private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.modalTitle = this.translate.instant('Copying status event page ') + this.pageName.toBold();
    this.modalCloningProcessNotification = this.translate.instant('A cloning process will be started for status event page %page configuration. Please refresh menu after some time to load new contents.').replace('%page', this.pageName.toBold());
  }

  onClose(): void {
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

  public onCopyStatusEventPage() {
    this.activeModal.close(this.selectedMachineIds);
  }

  public onCancel() {
    this.activeModal.dismiss(ModalDialogDismissOption.CANCEL);
  }

  public onUpdateSelectedMachines(selectedMachineIds: number[]) {
    this.selectedMachineIds = selectedMachineIds;
  }

}
